<template lang="pug">
v-app-bar.px-md-12(color="white" app elevate-on-scroll height=56)
  v-app-bar-nav-icon(
    v-show="$vuetify.breakpoint.smAndDown"
    @click="drawer = !drawer"
  )
  v-row(justify="space-between" style="height: 100%" no-gutters)
    v-col.d-flex.align-center(cols="auto")
      v-img(
        src="../assets/logo-colored.svg"
        alt="Imagem da Logo"
        @click="goToHome"
      )
    v-col.ml-16(cols="auto" v-show="$vuetify.breakpoint.mdAndUp")
      v-row(align="center" dense)
        v-col(cols="auto")
          v-tabs.heebo(
            color="primary"
            slider-color="grey darken-1"
            slider-size=4
            height=56
          )
            v-tab.primary--text.text-body-1.font-weight-medium.text-lowercase(
              to="/"
            ) para você
            v-tab.primary--text.text-body-1.font-weight-medium.text-lowercase(
              to="/empresa"
            ) para empresas
            v-tab.primary--text.text-body-1.font-weight-medium.text-lowercase(
              to="/planos"
            ) planos
            v-tab.primary--text.text-body-1.font-weight-medium.text-lowercase(
              to="/contato"
            ) contato
        v-col(cols="auto")
          v-btn.heebo.text-lowercase(
            color="primary"
            depressed
            disabled
            height=32
          ) entrar
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
  computed: {
    ...mapFields('page', ['drawer'])
  },
  methods: {
    goToHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="sass" scoped>
::v-deep
  .v-toolbar__content
    padding-top: 0 !important
    padding-bottom: 0 !important
</style>
